import { Validators } from '@angular/forms';
export const acceptedDecimals = new RegExp(/^[0-9]+(\.\d{1,5})?$/);
export const onlyInt = new RegExp(/^\d+$/);
export const placeholdersAndErrors = {
  'amount_minimum_s_future': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'amount_minimum_a_future': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'second_amount_minimum_s_future': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'second_amount_minimum_a_future': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'spread_percentage_future': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'spread_future': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'second_spread_percentage_future': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'second_spread_future': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'second_spread_percentage_future_a': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'second_spread_future_a': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'amount_minimum_options': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'spread_percentage_option': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'spread_option': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'average_daily_volume': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'frequency': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'ratio': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'screen_time': {'placeholder': 0 , 'error': 'ERROR_MESSAGES.ZERO'},
  'amount_position_future': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'adav': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'dispersion': {'placeholder': 1 , 'error': 'ERROR_MESSAGES.ZERO'},
  'spread_percentage_future_a': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'},
  'spread_future_a': {'placeholder': 0.00001 , 'error': 'ERROR_MESSAGES.ZERO'}
}
export const emailValid = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
export const validators = {
  'amount_minimum_s_future': [Validators.pattern(onlyInt)],
  'amount_minimum_a_future': [Validators.pattern(onlyInt)],
  'second_amount_minimum_s_future': [Validators.min(1), Validators.pattern(onlyInt)],
  'second_amount_minimum_a_future': [Validators.min(1), Validators.pattern(onlyInt)],
  'spread_percentage_future': [Validators.pattern(acceptedDecimals)],
  'spread_future': [Validators.pattern(acceptedDecimals)],
  'spread_percentage_future_a': [Validators.pattern(acceptedDecimals)],
  'spread_future_a': [Validators.pattern(acceptedDecimals)],
  'second_spread_percentage_future': [Validators.min(0.00001), Validators.pattern(acceptedDecimals)],
  'second_spread_future': [Validators.min(0.00001), Validators.pattern(acceptedDecimals)],
  'second_spread_percentage_future_a': [Validators.min(0.00001), Validators.pattern(acceptedDecimals)],
  'second_spread_future_a': [Validators.min(0.00001), Validators.pattern(acceptedDecimals)],
  'amount_minimum_options':  [Validators.pattern(onlyInt)],
  'spread_percentage_option': [Validators.pattern(acceptedDecimals)],
  'spread_option': [Validators.pattern(acceptedDecimals)],
  'average_daily_volume': [Validators.pattern(acceptedDecimals)],
  'frequency': [Validators.pattern(onlyInt)],
  'ratio': [Validators.pattern(acceptedDecimals)],
  'screen_time': [Validators.pattern(onlyInt)],
  'amount_position_future': [Validators.pattern(onlyInt)],
  'default_spread': [],
  'short_position_spread_future': [Validators.min(0.00001), Validators.pattern(acceptedDecimals)],
  'short_position_spread_percentage_future': [Validators.min(0.00001), Validators.pattern(acceptedDecimals)],
  'short_position_amount_minimum_s_future': [Validators.min(1), Validators.pattern(onlyInt)],
  'short_position_amount_minimum_a_future': [Validators.min(1), Validators.pattern(onlyInt)],
  'short_position_to_date': [],
  'short_position_from_date': [],
  'nominal_value': [],
  'id': [],
  'spread_type': [],
  'adav': [Validators.pattern(onlyInt), Validators.min(1)],
  'dispersion': [Validators.min(1), Validators.max(100), Validators.pattern(onlyInt)],
  'currencies': [],
  'settlement_periods': []
}
export const minCaps = new RegExp(/(?=.*[A-Z])/);
export const minLower = new RegExp(/(?=.*[a-z])/);
export const minNums = new RegExp(/(?=.*[0-9])/);
export const minSpecials = new RegExp(/(?=.*[\W_])/);
export const passwordPattern = new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{12,}$/);